/// <reference path="/js/viz/map/lib/proj4js-combined.js"/>

(function($, Proj4js, google) {
  var ns = nspace("ccc.viz.map.util");

  var wgs84Coords = new Proj4js.Proj("WGS84");
  var epsg3857Coords = new Proj4js.Proj("GOOGLE");

  // These regexes and the WKT polygon parsing code is roughly based off code found in OpenLayers
  // https://github.com/openlayers/openlayers/blob/master/lib/OpenLayers/Format/WKT.js
  var regExes = {
    typeStr: /^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,
    parenComma: /\)\s*,\s*\(/,
    doubleParenComma: /\)\s*\)\s*,\s*\(\s*\(/,
    trimParens: /^\s*\(?(.*?)\)?\s*$/
  };

  function getPolygonLatLngs(coords) {
    // Expects polygon text that looks like this:
    // -12211621.104157 4438929.90942386, ... , -12212798.9101653 4438929.90942386

    // split into coord pairs
    var pairs = coords.split(", ");
    var latLngs = [];
    for (var i = 0; i < pairs.length; i++) {
      // create a new LatLng from each pair
      var parts = pairs[i].split(" ");
      var lat = parseFloat(parts[1]);
      var lng = parseFloat(parts[0]);

      latLngs.push(new google.maps.LatLng(lat, lng));
    }

    return latLngs;
  }

  function parsePolygon(text) {
    var paths = [];
    var rings = $.trim(text).split(regExes.parenComma);
    for (var i = 0, len = rings.length; i < len; ++i) {
      var ring = rings[i].replace(regExes.trimParens, "$1");
      paths.push(getPolygonLatLngs(ring));
    }

    return paths;
  }

  function parseMultiPolygon(text) {
    var polygon;
    var polygons = $.trim(text).split(regExes.doubleParenComma);
    var paths = [];
    for (var i = 0, len = polygons.length; i < len; ++i) {
      polygon = polygons[i].replace(regExes.trimParens, "$1");
      var polyPaths = parsePolygon(polygon);
      for (var j = 0; j < polyPaths.length; j++) {
        paths.push(polyPaths[j]);
      }
    }
    return paths;
  }

  ns.MapUtil = {
    /**
     * Translates latitude and longitude into screen pixel coordinates relative to the map container
     */
    fromPositionToRelativePixels: function(gmap, position) {
      var scale = Math.pow(2, gmap.getZoom());
      var worldXY = new google.maps.LatLng(
        gmap
          .getBounds()
          .getNorthEast()
          .lat(),
        gmap
          .getBounds()
          .getSouthWest()
          .lng()
      );
      var worldEdge = gmap.getProjection().fromLatLngToPoint(worldXY);
      var worldPosition = gmap.getProjection().fromLatLngToPoint(position);

      return {
        x: Math.floor((worldPosition.x - worldEdge.x) * scale),
        y: Math.floor((worldPosition.y - worldEdge.y) * scale)
      };
    },

    /**
     * Converts a latitude/longitude in EPSG 3857 (web mercator meters) to wgs84 (degrees)
     */
    epsg3857ToWgs84: function(lat, lng) {
      var p = new Proj4js.Point(lng, lat);
      Proj4js.transform(epsg3857Coords, wgs84Coords, p);
      return new google.maps.LatLng(p.y, p.x);
    },

    /**
     * Converts a google Point in wgs84 (degrees) to EPSG 3857 (web mercator meters)
     */
    wgs84ToEpsg3857: function(googlePoint) {
      var p = new Proj4js.Point(googlePoint.lng(), googlePoint.lat());
      Proj4js.transform(wgs84Coords, epsg3857Coords, p);
      return p;
    },

    /**
     * Converts a polygon in WKT format (Well Known Text) into a google maps polygon
     */
    wktToGooglePolygon: function(wktPolygon) {
      // WKT Polygon examples available here: http://en.wikipedia.org/wiki/Well-known_text

      var paths = [];

      wktPolygon = wktPolygon.replace(/[\n\r]/g, " ");
      var matches = regExes.typeStr.exec(wktPolygon);
      if (matches) {
        var type = matches[1].toLowerCase();
        var text = matches[2];
        if (type === "multipolygon") {
          paths = parseMultiPolygon(text);
        }
        else if (type === "polygon") {
          paths = parsePolygon(text);
        }
        else {
          throw "Unrecognized feature type: " + type;
        }
      }

      // create a polygon from the LatLngs
      var polygon = new google.maps.Polygon({
        paths: paths,
        fillColor: "#eee",
        fillOpacity: 0.9,
        strokeColor: "#e2ecec",
        strokeWeight: 1
      });

      return polygon;
    }
  };
})(jQuery, Proj4js, google);
